import React from 'react';
import i18next from "../../i18n";
import * as constants from '../../constants';
import { getArrayIds, encodeHTMLEntities } from '../helpers/HelperFunctions';
import { Table } from '../table/Table';
import { TableFilterBlock } from '../table/TableFilterBlock';
import { loadListData } from './ListHelpers';
import { showModalDialog } from './../ModalDialog';
import * as CEDService from '../services/CEDService';
export async function loadData(page, pageSize, sortBy = '', isDesk = false, filterValues = []) {
    filterValues = Object.assign([], filterValues);
    filterValues = Object.assign(filterValues, this.props.additionalFilter);
    filterValues.State = [constants.alfrescoUserSates.Active];
    await loadListData.bind(this)(`Table/Get?searchTableTypes=${constants.searchTableTypes.Users}&withAction=${false}`, page, pageSize, sortBy, isDesk, filterValues);
}
export async function actionHandlerCallback(actionType, ids) {
    const { content } = this.state;
    const { prop_sys_node_uuid } = this.props;
    if (ids.length > 0) {
        switch (actionType) {
            case constants.actionTypes.add:
                if (await this.checkChangeExecutorPermission.bind(this)()) {
                    let rows = content.rows.filter(row => ids.indexOf(row.columns['Id']) !== -1);
                    await CEDService.action("get", `document/changeTaslExecuter?email=${rows[0].columns.Email}&id=${prop_sys_node_uuid}`, null, () => { window.onbeforeunload = null; window.location.reload() });
                }
                break;
            default: await this.actionHandlerCallbackDefault(actionType, ids);
        }
    }
}
export async function checkChangeExecutorPermission() {
    const { prop_sys_node_uuid } = this.props;
    let result = await fetch(`Document/CheckActionPermission?id=${prop_sys_node_uuid}&actionName=ChangeExecuter`, { method: "GET" })
        .then(async (res) => {
            const data = await res.json();
            let modalCloseFunction = async function () {
                window.onbeforeunload = null;
                window.location.reload()
            }
            if (!data.success) {
                showModalDialog('loadingDialog', i18next.t("error"), "", <div className="info-message">{data.errorMessage}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: modalCloseFunction, class: "btn-primary" }], modalCloseFunction);
            }
            return data.success;
        });
    return result;
}
export function renderContent() {
    const { content, page, pageSize, pageCount, sortBy, isDesk, filterValues } = this.state;
    const { companyName } = this.props;
    if (content) content.actionsForAll = [
        { "title": i18next.t("15"), "type": constants.actionTypes.add, "isMultiaction": false, "btnClass": "btn-primary", "sortIndex": -1 }
    ];
    let contentRows = content?.rows ?? [];
    if (companyName && contentRows.length > 0) {
        contentRows.forEach(row => {
            row.columns.CompanyName = encodeHTMLEntities(companyName);
        });
    }
    return (<div>
        <TableFilterBlock filterValues={filterValues} exportFileName="users" onSearch={this.onSearch} onSearchClear={this.onSearchClear} onColumnsUpdateHandler={this.onColumnsUpdateHandler} columnsSettings={{ columns: (content && content.allColumns) ? content.allColumns : [], selected: (content && content.columns) ? getArrayIds(content.columns) : [] }} getItems={this.getItemsForExport} />
        {content && content.columns &&
            <Table onColumnFilter={this.onColumnFilter} allowDoubleClickAction={true} allCount={content.allCount} handleSortChange={this.handleSortChange} actionHandlerCallback={this.actionHandlerCallback} actionsForAll={content.actionsForAll} columns={content.columns} sortBy={sortBy} isDesk={isDesk} items={contentRows} showPagination={true} page={page} pageSize={pageSize} pageCount={pageCount} handlePageChange={this.handlePageChange} handleChangePageSize={this.handleChangePageSize} />
        }
    </div>);
}